import React, { useState } from 'react';

interface WritingActivityProps {
  emotion: string;
  onComplete: () => void;
}

const WritingActivity: React.FC<WritingActivityProps> = ({ emotion, onComplete }) => {
  const [content, setContent] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);
  const [wordCount, setWordCount] = useState(0);

  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setContent(text);
    setWordCount(text.trim().split(/\s+/).filter(word => word.length > 0).length);
  };

  const handleComplete = () => {
    if (content.trim().length > 0) {
      setIsCompleted(true);
      setTimeout(() => {
        onComplete();
      }, 2000);
    }
  };

  if (isCompleted) {
    return (
      <div className="text-center">
        <div className="text-6xl mb-6">✍️</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          글쓰기 완료!
        </h2>
        <p className="text-gray-600 mb-6">
          {emotion}을 글쓰기로 표현했습니다
        </p>
        <div className="bg-yellow-50 rounded-2xl p-6 mb-6">
          <h3 className="text-lg font-semibold mb-4">작성 요약</h3>
          <div className="grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-mint">{wordCount}</div>
              <div className="text-sm text-gray-600">작성한 단어</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-mint">{emotion}</div>
              <div className="text-sm text-gray-600">감정</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="text-center">
        <div className="text-6xl mb-4">✍️</div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          감정 글쓰기
        </h2>
        <p className="text-gray-600 mb-6">
          오늘 있었던 일이나 느낀 감정에 대해 자유롭게 작성해보세요
        </p>
      </div>

      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-600">
            감정: {emotion}
          </span>
          <span className="text-sm text-gray-500">
            {wordCount}단어
          </span>
        </div>
        
        <div className="bg-white rounded-2xl border border-grey p-4">
          <textarea
            value={content}
            onChange={handleContentChange}
            placeholder="여기에 작성해주세요..."
            className="w-full h-64 p-4 resize-none border-none outline-none text-gray-900"
            style={{ fontFamily: 'inherit', fontSize: '16px', lineHeight: '1.6' }}
          />
        </div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={handleComplete}
            disabled={content.trim().length === 0}
            className="btn-primary px-8 py-3 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            작성 완료
          </button>
        </div>
      </div>
    </div>
  );
};

export default WritingActivity; 